import { differenceInMinutes, parseISO } from 'date-fns'

import { GetJobQuery, UpdateJobMutationVariables } from '@/types/graphql'

export type ShiftRange = {
  startAt: Date
  endAt: Date
}

export enum JobStatus {
  UPCOMING = 'upcoming',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

const MINS_IN_DAY = 24 * 60

export const getShiftIntervals = (shifts: GetJobQuery['job']['shifts']) => {
  const intervals: ShiftRange[][] = []

  shifts.forEach((shift) => {
    const lastInterval = intervals[intervals.length - 1]

    const startAt = parseISO(shift.startAt)
    const endAt = parseISO(shift.endAt)

    if (!lastInterval || lastInterval.length === 0) {
      return intervals.push([{ startAt, endAt }])
    }

    const lastShift = lastInterval[lastInterval.length - 1]

    if (
      differenceInMinutes(startAt, lastShift.startAt) !== MINS_IN_DAY ||
      differenceInMinutes(endAt, lastShift.endAt) !== MINS_IN_DAY
    ) {
      intervals.push([{ startAt, endAt }])
    } else {
      lastInterval.push({ startAt, endAt })
    }
  })

  return intervals
}

export const getJobValues = (
  job: GetJobQuery['job']
): UpdateJobMutationVariables => {
  return {
    jobId: job.id,
    addressInstructions: job.addressInstructions ?? '',
    contactId: job.contact.id,
    contactInstructions: job.contactInstructions ?? '',
    instructions: job.instructions ?? '',
    uniformId: job.uniform.id,
    uniformInstructions: job.uniformInstructions ?? '',
  }
}
